import AppTabs from 'general/components/AppTabs';
import AppColors from 'general/constants/AppColors';
import useRouter from 'hooks/useRouter';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AnimatePresence, motion } from 'framer-motion';
import GroupReconciliationTabView from '../../components/GroupReconciliationTabView';
import SaleReconciliationTabView from '../../../components/SaleReconciliationTabView';

GroupReconciliationListScreen.propTypes = {
    agencyId: PropTypes.string,
};

function GroupReconciliationListScreen(props) {
    // MARK: ---- PROPERTIES ----
    const { agencyId } = props;
    const { t } = useTranslation();
    const router = useRouter();

    const tabs = useMemo(() => {
        return [
            'Đối soát đầu tư',
            'Đối soát bán hàng',
        ].reverse()
    }, []);
    const [selectedTab, setSelectedTab] = useState(t('Đối soát đầu tư'));
    const hash = router?.location?.hash;
    useEffect(() => {
        if (hash === '#group-reconciliation') setSelectedTab('Đối soát đầu tư');
        if (hash === '#sale-reconciliation') setSelectedTab(t('Đối soát bán hàng'));
    }, [hash]);

    const groupReconciliationTabView = useMemo(() => {
        return (
            <GroupReconciliationTabView />
        );
    }, []);

    const saleReconciliationTabView = useMemo(() => {
        return (
            <SaleReconciliationTabView primaryRole='GROUP' />
        );
    }, []);

    // MARK: ---- METHODS ----

    const handleSelectedTab = (newTab) => {
        if (selectedTab === newTab) return;
        if (newTab === 'Đối soát đầu tư') {
            router.navigate('#group-reconciliation');
        }
        if (newTab === 'Đối soát bán hàng') {
            router.navigate('#sale-reconciliation');
        }
        setSelectedTab(newTab);
    };

    return (
        <div className='px-4'>
            <div className="pt-0">
                <AppTabs
                    tabs={tabs}
                    activeTab={selectedTab}
                    handleClick={handleSelectedTab}
                    className="mt-3 mr-3"
                    additionalClassName=""
                />
                <div
                    className="bg-white shadow"
                    style={{
                        borderLeft: `1px solid ${AppColors.gray[300]}`,
                        borderRight: `1px solid ${AppColors.gray[300]}`,
                        borderBottom: `1px solid ${AppColors.gray[300]}`,
                        borderRadius: '0px 10px 10px 10px',
                    }}
                >
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={selectedTab}
                            initial={{ y: 10, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            exit={{ y: -10, opacity: 0 }}
                            transition={{ duration: 0.2 }}
                        >
                            {selectedTab == 'Đối soát đầu tư' && (
                                <div className="py-4">{groupReconciliationTabView}</div>
                            )}
                            {selectedTab == 'Đối soát bán hàng' && (
                                <div className="pb-3 pt-4">{saleReconciliationTabView}</div>
                            )}
                        </motion.div>
                    </AnimatePresence>
                </div>
            </div>
        </div>
    );
}

export default GroupReconciliationListScreen;
